export const borderWidths = {
    default: 1,
};
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiYm9yZGVyV2lkdGhzLmpzIiwic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsiLi4vLi4vc3JjL3RoZW1lL2JvcmRlcldpZHRocy50cyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiQUFJQSxNQUFNLENBQUMsTUFBTSxZQUFZLEdBQWlCO0lBQ3hDLE9BQU8sRUFBRSxDQUFDO0NBQ1gsQ0FBQyJ9